import { Store } from 'vuex';

export const state = () => ({});

export const actions = {
    /**
     * Получение конфигурации сайта
     */
    async nuxtServerInit<S = any>(this: any, store: Store<S>, app: any): Promise<void> {
        try {
            const cookieSessionToken = app.$cookies.get('sessionToken');
            const currentHost = app?.req?.headers?.host || "";

            const res = await store.dispatch('appState/GET_REQUEST', '/configs', { root: true });

            if (!cookieSessionToken) {
                const cookiesOpt = app.$getCookiesOpt({
                    path: '/',
                    maxAge: 60 * 60 * 24 * 60,
                });
                app.$cookies.set('sessionToken', res.headers['x-session-token'], cookiesOpt);
            }
            store.commit('local-settings/setCurrentHost', currentHost);
            store.commit('distillation/initNewVersion');

            store.commit('appState/setConfig', res.data, { root: true });
        } catch (e) {
            console.error('Невозможно получить конфигурацию ', e);
        }
    },
};
